export default {
    /* GET_PRODUCTS
    ---------------------------------------------------------------
    */
    GET_PRODUCTS_REQUEST: state => {
        state.productsLoading = true
    },
    GET_PRODUCTS_SUCCESS: (state, data) => {
        state.products = data.results
        state.productsLoading = false
    },
    GET_PRODUCTS_FAILURE: state => {
        state.productsLoading = false
    },
    SET_PRODUCTS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PRODUCTS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}

